export default __webpack_public_path__ + "ab4bb56a4eb882c1c41aada558e417a0.svg";